module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/064fcba3fb7ff24397f9247e7365bae5.gif";